(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["av-commerce-hero"] && !Shopify.designMode) return;
  try {
    
  const avInitCommerceHeroMotion = (scope = document) => {
    scope.querySelectorAll('[data-av-commerce-hero-motion]').forEach((video) => {
      if (video.dataset.avMotionInitialized === 'true') return;
      video.dataset.avMotionInitialized = 'true';

      const hero = video.closest('.av-commerce-hero');
      const mobileQuery = window.matchMedia('(max-width: 749px)');
      const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
      const connection = navigator.connection || navigator.mozConnection || navigator.webkitConnection;

      if (!hero || reducedMotion.matches || connection?.saveData) return;

      let started = false;

      const selectSource = () => {
        const source = mobileQuery.matches ? video.dataset.mobileSrc : video.dataset.desktopSrc;
        const poster = mobileQuery.matches ? video.dataset.mobilePoster : video.dataset.desktopPoster;

        if (!source || video.dataset.currentSource === source) return;

        hero.classList.remove('is-motion-ready');
        video.pause();
        video.dataset.currentSource = source;
        video.poster = poster || '';
        video.src = source;
        video.load();
      };

      const maxAutomaticMotionSeconds = 5;

      const playWhenReady = () => {
        selectSource();

        const playIfDurationIsAccessible = () => {
          const duration = video.duration;
          if (!Number.isFinite(duration) || duration <= 0 || duration > maxAutomaticMotionSeconds) {
            hero.classList.remove('is-motion-ready');
            video.pause();
            return;
          }

          const playPromise = video.play();
          if (playPromise) playPromise.catch(() => {});
        };

        if (video.readyState >= 1) playIfDurationIsAccessible();
        else video.addEventListener('loadedmetadata', playIfDurationIsAccessible, { once: true });
      };

      video.addEventListener('playing', () => hero.classList.add('is-motion-ready'));
      video.addEventListener('error', () => hero.classList.remove('is-motion-ready'));

      const observer = new IntersectionObserver((entries) => {
        if (!entries[0]?.isIntersecting || started) return;
        started = true;
        playWhenReady();
        observer.unobserve(hero);
      }, { rootMargin: '120px 0px', threshold: 0.15 });

      observer.observe(hero);
      mobileQuery.addEventListener('change', () => {
        if (!started) selectSource();
      });
    });
  };

  avInitCommerceHeroMotion();
  document.addEventListener('shopify:section:load', (event) => avInitCommerceHeroMotion(event.target));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["good-vibes-orbit-hero"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('good-vibes-orbit')) {
    class GoodVibesOrbit extends HTMLElement {
      connectedCallback() {
        if (this.initialized) return;
        this.initialized = true;
        this.reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
        this.finePointer = window.matchMedia('(hover: hover) and (pointer: fine)');
        this.visual = this.querySelector('.good-vibes-orbit__visual');
        this.motion = this.querySelector('[data-gvo-motion]');
        this.motionPreset = this.dataset.motionPreset || 'reveal';
        const editorMode = Boolean(window.Shopify && window.Shopify.designMode);

        if (this.motionPreset === 'still' || this.reducedMotion.matches || editorMode) {
          this.classList.add('is-revealed');
        } else {
          this.classList.add('gvo-motion-ready');
          this.revealObserver = new IntersectionObserver((entries) => {
            if (!entries.some((entry) => entry.isIntersecting)) return;
            this.classList.add('is-revealed');
            this.revealObserver.disconnect();
          }, { rootMargin: '0px 0px -8% 0px', threshold: 0.16 });
          this.revealObserver.observe(this);
        }

        const connection = navigator.connection || navigator.mozConnection || navigator.webkitConnection;
        const constrainedConnection = Boolean(connection && (connection.saveData || connection.effectiveType === 'slow-2g' || connection.effectiveType === '2g'));
        if (this.motion && !this.reducedMotion.matches && !editorMode && !constrainedConnection) {
          this.motionObserver = new IntersectionObserver((entries) => {
            if (!entries.some((entry) => entry.isIntersecting)) return;
            this.motionObserver.disconnect();
            this.startFiniteMotion();
          }, { rootMargin: '120px 0px', threshold: 0.12 });
          this.motionObserver.observe(this);
        }

        if (this.dataset.pointerDepth === 'true' && this.finePointer.matches && !this.reducedMotion.matches && this.visual) {
          this.pointerMove = (event) => {
            if (this.pointerFrame) cancelAnimationFrame(this.pointerFrame);
            this.pointerFrame = requestAnimationFrame(() => {
              const rect = this.visual.getBoundingClientRect();
              const x = ((event.clientX - rect.left) / rect.width - 0.5) * 10;
              const y = ((event.clientY - rect.top) / rect.height - 0.5) * 8;
              this.visual.style.setProperty('--gvo-depth-x', `${x.toFixed(2)}px`);
              this.visual.style.setProperty('--gvo-depth-y', `${y.toFixed(2)}px`);
            });
          };
          this.pointerLeave = () => {
            this.visual.style.setProperty('--gvo-depth-x', '0px');
            this.visual.style.setProperty('--gvo-depth-y', '0px');
          };
          this.visual.addEventListener('pointermove', this.pointerMove, { passive: true });
          this.visual.addEventListener('pointerleave', this.pointerLeave, { passive: true });
        }
      }

      startFiniteMotion() {
        const mobile = window.matchMedia('(max-width: 749px)').matches;
        const source = mobile
          ? this.motion.dataset.mobileSrc || this.motion.dataset.desktopSrc
          : this.motion.dataset.desktopSrc || this.motion.dataset.mobileSrc;
        if (!source) return;

        this.motionLimit = Number(this.motion.dataset.duration) || 5;
        this.motion.src = source;
        this.motion.load();
        this.onMotionPlaying = () => this.classList.add('is-motion-playing');
        this.onMotionTimeUpdate = () => {
          if (this.motion.currentTime < this.motionLimit) return;
          this.motion.pause();
          this.classList.remove('is-motion-playing');
          this.motion.removeEventListener('timeupdate', this.onMotionTimeUpdate);
        };
        this.onMotionEnded = () => this.classList.remove('is-motion-playing');
        this.motion.addEventListener('playing', this.onMotionPlaying, { once: true });
        this.motion.addEventListener('timeupdate', this.onMotionTimeUpdate);
        this.motion.addEventListener('ended', this.onMotionEnded, { once: true });
        const playback = this.motion.play();
        if (playback) playback.catch(() => this.classList.remove('is-motion-playing'));
      }

      disconnectedCallback() {
        this.revealObserver?.disconnect();
        this.motionObserver?.disconnect();
        if (this.pointerFrame) cancelAnimationFrame(this.pointerFrame);
        if (this.visual && this.pointerMove) this.visual.removeEventListener('pointermove', this.pointerMove);
        if (this.visual && this.pointerLeave) this.visual.removeEventListener('pointerleave', this.pointerLeave);
        if (this.motion) {
          this.motion.pause();
          if (this.onMotionPlaying) this.motion.removeEventListener('playing', this.onMotionPlaying);
          if (this.onMotionTimeUpdate) this.motion.removeEventListener('timeupdate', this.onMotionTimeUpdate);
          if (this.onMotionEnded) this.motion.removeEventListener('ended', this.onMotionEnded);
          this.motion.removeAttribute('src');
          this.motion.load();
        }
        this.initialized = false;
      }
    }

    customElements.define('good-vibes-orbit', GoodVibesOrbit);
  }

  } catch(e) { console.error(e); }
})();
})();
